/* Categoria de um finding do scanner, DERIVADA do `ruleId` (ADR-0474). O contrato client-safe
   `scannerFindingDto` (ADR-0462 §3) NÃO carrega `category` — a derivação é client-side, allowlist
   EXATA por rule ID de asset/deps + fallback `code`. As constantes espelham o pack-scanner
   (`engine/scan-data.ts` `data-embedded-payload` / `engine/scan-deps.ts` `bundled-deps-present`) —
   NÃO importadas (boundary client-safe), só espelhadas. */

export type FindingCategory = 'code' | 'data' | 'deps';

/* Rule IDs de asset/deps → categoria. Qualquer outro (regras de código em engine/rules.ts, ou
   regra futura desconhecida) cai em `code` (fallback seguro). */
const RULE_CATEGORY: Readonly<Record<string, FindingCategory>> = {
  'data-embedded-payload': 'data',
  'bundled-deps-present': 'deps',
};

export function categorizeFinding(ruleId: string): FindingCategory {
  return RULE_CATEGORY[ruleId] ?? 'code';
}

/* Ordem estável de exibição dos grupos (relance: código → dados → deps). */
export const CATEGORY_ORDER: readonly FindingCategory[] = ['code', 'data', 'deps'];

export interface FindingCategoryLabels {
  readonly code: string;
  readonly data: string;
  readonly deps: string;
}

/* Default pt-BR — mantém os call sites que não passam `labels` (testes, uso fora do provedor de
   idioma) funcionando sem quebrar. `scan-findings-card.tsx` passa os rótulos bilíngues resolvidos
   do próprio `usePackSubmissionsContent()` (ADR-0811). */
const DEFAULT_FINDING_CATEGORY_LABELS: FindingCategoryLabels = {
  code: 'Código',
  data: 'Dados/assets',
  deps: 'Dependências bundladas',
};

/** Rótulo da categoria (switch exaustivo — sem `default` p/ o TS acusar membro novo). */
export function categoryLabel(
  category: FindingCategory,
  labels: FindingCategoryLabels = DEFAULT_FINDING_CATEGORY_LABELS,
): string {
  switch (category) {
    case 'code':
      return labels.code;
    case 'data':
      return labels.data;
    case 'deps':
      return labels.deps;
  }
}
